import { createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../utilities/BASE_URL';
import { postWithToken } from '../utilities/fetchWithToken';

// Freeze-time REST thunks (mirrors pupApi's postPup factory). Errors come back as the
// server's plain-text 400 body — the queue endpoint's post-execution rejection is EXACTLY
// "already executed a queued freeze", which GameTable keys the 4s center notice on.
const postFreeze = (type, path, fallback, shape = (data, arg) => ({ ...arg, ...data })) =>
  createAsyncThunk(type, async (arg, { rejectWithValue }) => {
    try {
      const response = await postWithToken(`${BASE_URL}${path}`, arg);
      if (!response.ok) return rejectWithValue((await response.text()) || fallback);
      return shape(await response.json(), arg);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

// Active freeze: spend the freeze time bank to stop the table until Unfreeze / an accepted
// action / the bank runs out. The FREEZE_STARTED broadcast + snapshot carry the new state.
export const freezeTime = postFreeze(
  'freeze/freezeTime', '/games/freeze', 'Failed to freeze time');
// End this player's own freeze (active or queued) — FREEZE_ENDED + snapshot follow.
export const unfreezeTime = postFreeze(
  'freeze/unfreezeTime', '/games/unfreeze', 'Failed to unfreeze time');
// Queue (or toggle off / replace) the one-per-round 10s freeze at a stage/phase point.
// Success returns { queuedFreeze, queuedFreezeUsed } — the selection is PRIVATE (no
// broadcast), so it has a fulfilled reducer in gameSlice.
export const queueFreeze = postFreeze(
  'freeze/queueFreeze', '/games/freezequeue', 'Failed to queue a freeze');
